import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Web3Provider } from "./Service/Web3/Web3Context";
import LanguageContextProvider from './Languages/LanguageContext';

import App from './App';
import './assets/styles/index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <LanguageContextProvider>
            <Web3Provider> {/* Web3Provider bileşenini buraya ekleyin */}
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </Web3Provider>
        </LanguageContextProvider>
    </React.StrictMode>
);
